import React, { FC } from 'react'
import { Spacer } from 'components/Utility'
import text from 'styles/utility/text.module.scss'
import { parseNumberToTime } from 'lib/helper'

type Props = {
  align: 'center' | 'left' | 'right'
  lastNotifiedMinutes: number
}

const NotificationDescription: FC<Props> = React.memo((props) => {
  const { align, lastNotifiedMinutes } = props

  return (
    <>
      <Spacer size={4} />
      <p className={`${text.font_small} ${text[`align_${align}`]}`} data-cy={'notification-description'}>
        あと
        <span className={text.color_orange_main}>{parseNumberToTime(30 - lastNotifiedMinutes)}</span>
        で通知を送れるようになります
      </p>
    </>
  )
})

export default NotificationDescription
